import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { convertToGeoJsonRoute } from '../utils/useGeoJson';

import { config } from '../config';

async function callGetApi(endPoint, params) {
  let headers = new Headers();
  var url = new URL(`${config.url.API_BASE_URL}/${endPoint}`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return fetch(url, {
    method:'GET',
    headers: headers,
  });
}

const callGetRouteApi = async (params) => {
  let headers = new Headers({
    'Authorization': 'Basic c29tZXdhcmU6fjJWMkphamZLaDlVWGkyfnIyWjc=',
    'Content-Type': 'application/json'
  });
  var url = new URL(`${config.url.API_ROUTE_URL}`);
  return fetch(url, {
    method:'POST',
    headers: headers,
    body: JSON.stringify(params)
  });
};

export const getRoute = (profile, multimodal, from, to, date) => {
  const {i18n} = useTranslation();
  const lang = i18n.language === 'en' ? 'en-EN' : 'fr-FR';
  const params = () => {
    if (profile === 'walking') {
      if (multimodal) {
        return {
          'costing': 'multimodal',
          'pedestrian_costing': 'walking',
          'alternates': 2, 
          'costing_options': {
            'transit': {
              'use_bus':0.5,
              'use_rail':0.5,
              'use_transfers':0.5,
              'transit_start_end_max_distance':2145,
              'transit_transfer_max_distance':800
            }
          },
          'date_time': {
            'type': 1,
            'value': date.format('YYYY-MM-DDTHH:mm')
          },
          'locations': [
            {
              'lon': from[0],
              'lat': from[1]
            },
            {
              'lon': to[0],
              'lat': to[1]
            }
          ],
          'directions_options':{
            'language': lang,
          }
        };
      } else {
        return {
          'costing': 'walking',
          'alternates': 2,
          'locations': [
            {
              'lon': from[0],
              'lat': from[1]
            },
            {
              'lon': to[0],
              'lat': to[1]
            }
          ],
          'directions_options':{
            'language': lang,
          }
        };
      }
    } else {
      if (multimodal) {
        return  {
          'costing': 'multimodal',
          'pedestrian_costing': 'access',
          'alternates': 2, 
          'costing_options': {
            'transit': {
              'use_bus':0.5,
              'use_rail':0.5,
              'use_transfers':0.5,
              'transit_start_end_max_distance':2145,
              'transit_transfer_max_distance':800
            },
            'access': {
              'exclude_polygons': [],
              'use_hills': 0.5,
              'impaired_profile': profile,
              'avoid_bad_surfaces': 0,
              'travel_speed': 4,
              'exclude_steps': false,
            }
          },
          'date_time': {
            'type': 1,
            'value': date.format('YYYY-MM-DDTHH:mm')
          },
          'locations': [
            {
              'lon': from[0],
              'lat': from[1]
            },
            {
              'lon': to[0],
              'lat': to[1]
            }
          ],
          'directions_options':{
            'language': lang,
          }
        };
      } else {
        return {
          'costing': 'access',
          'costing_options': {
            'transit': {
              'use_bus':0.5,
              'use_rail':0.5,
              'use_transfers':0.5,
              'transit_start_end_max_distance':2145,
              'transit_transfer_max_distance':800
            },
            'access': {
              'exclude_polygons': [],
              'use_hills': 0.5,
              'impaired_profile': profile,
              'avoid_bad_surfaces': 0,
              'travel_speed': 4,
              'exclude_steps': false,
            }
          },
          'alternates': 2,
          'locations': [
            {
              'lon': from[0],
              'lat': from[1]
            },
            {
              'lon': to[0],
              'lat': to[1]
            }
          ],
          'directions_options':{
            'language': lang,
          }
        };
      }
    }
  };
  const { status, data, error, refetch } = useQuery([profile, multimodal, from[0], from[1], to[0], to[1], date], async () => {
    try {
      const response = await callGetRouteApi(params());
      if (!response.ok) {
        throw new Error("Une erreur est survenue, la requête n'a pas pu être exécutée correctement");
      }
      return response.json();
    } catch (error) {
      throw new Error("Une erreur est survenue, l'itinéraire n'a pas pu être calculé, veuillez réessayer plus tard ou en modifiant le point d'arrivée ou de départ.");
    }
  },
  {
    enabled: (typeof profile !== 'undefined' && profile && typeof from !== 'undefined' && from && typeof to !== 'undefined' && to && typeof date !== 'undefined' && date && from.length > 1 && to.length > 1)
  }
  );

  let results = [];
  let allResults = [];

  /**
   * Dans le cas de profil sans transport avec un point dehors de zone sélectionné
   * status "success" est retourné mais avec un objet avec code_erreur et sans "data.trip"
   * Mettre si data et data.trip existe qu'on va exécuter construire les données retournées
   */

  if (data && data.trip) {
    const {summary, legs, locations} = data.trip;
    /**
     * S'il n'existe pas de données dans "data", n'ajoute pas dans results
     */
    if (summary && locations && legs) {
      results.push({
        length: summary.length,
        locations,
        bbox: [summary.min_lon, summary.min_lat, summary.max_lon, summary.max_lat],
        time: summary.time,
        legs: legs[0],
        obstacles: summary.has_obstacles,
        access_score: summary.access_score
      });
    }
    const tripsAlternate = data.alternates;
    if ( tripsAlternate && tripsAlternate.length > 0 ) {
      tripsAlternate.forEach(elem => {
        const {summary, legs, locations} = elem.trip; 
        results.push({
          length: summary.length,
          locations,
          bbox: [summary.min_lon, summary.min_lat, summary.max_lon, summary.max_lat],
          time: summary.time,
          legs: legs[0],
          obstacles: summary.has_obstacles,
          access_score: summary.access_score
        });
      });
    }
    results.forEach(elem => {
      const geojsonFeature = convertToGeoJsonRoute(elem.legs, profile);
      allResults.push({
        length: elem.length * 1000,
        time: elem.time,
        locations: elem.locations,
        obstacles: elem.obstacles,
        access_score: elem.access_score,
        geojson: {
          type: 'FeatureCollection',
          features: geojsonFeature
        }
      });
    });
  } else {
    allResults = [];
  }
  return {status, allResults, error, refetch};
};

export function GetGraph(profile) {
  const params = {
    profile: profile
  };

  const { status, data, error } = useQuery(['graph', profile], async () => {
    try {
      const response = await callGetApi(`${config.city}/map`, params);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    } catch(error) {
      throw new Error ('Une erreur est survenue');
    } 
  });

  return { status, data, error };
}

export function getPath(profile, multimodal, from, to) {
  const { status, data, error } = useQuery(['graph', profile, multimodal, from[0], from[1], to[0], to[1]], async () => {
    const [from_lon, from_lat] = from;
    const [to_lon, to_lat] = to;
    const params = {
      from: `${from_lon},${from_lat}`,
      to: `${to_lon},${to_lat}`,
      profile: profile,
      num: 2,
      options: multimodal ? 'transportation=1': 'transportation=0'
    };
    try {
      const response = await callGetApi(`${config.city}/paths`, params);
      if (!response.ok) {
        throw new Error("Une erreur est survenue, la requête n'a pas pu être exécutée correctement");
      }
      return response.json();
    } catch (error) {
      console.log('error', error);
      throw new Error("Une erreur est survenue, l'itinéraire n'a pas pu être calculé, veuillez réessayer plus tard ou en modifiant le point d'arrivée ou de départ.");
    }
  },
  {
    enabled: (typeof profile !== 'undefined' && profile && typeof from !== 'undefined' && from && typeof to !== 'undefined' && to && from.length > 1 && to.length > 1)
  });
  let allResults = [];
  if (data) {
    data.map((result, i) => {
      allResults.push({
        length: result.length,
        geojson: {
          type: 'FeatureCollection',
          features: result.path.features.map((f, j) => ({
            ...f,
            properties: {
              ...f.properties,
              id: `${i}_${j}`,
            }
          }))
        }
      }
      );
    });
  }
  return { status, allResults, error };
}
